module.exports = __webpack_public_path__ + "img/15.3261f615.jpg";